// extracted by mini-css-extract-plugin
module.exports = {"avatar":"ContactAvatar-hashed__avatar__201nP","inactive":"ContactAvatar-hashed__inactive__38qb6","active":"ContactAvatar-hashed__active__3b3zh"};